module.exports = __webpack_public_path__ + "img/OTHER.2df9a6c8.jpg";